<template>
  <v-container id="page-vehicle-model-list">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn color="blue" class="ml-1" outlined iconName="add" @click="openVehicleModelDialog">차량모델등록</c-btn>
        <c-btn class="ml-1" color="blue" outlined iconName="delete" @click="onDeleteVehicleModels">차량모델삭제</c-btn>
      </v-col>
    </v-row>

    <c-table
      :headers="vehicleModelTableHeaders"
      :items="vehicleModelList"
      itemKey="id"
      show-select
      :selected.sync="selected"
    >
      <template #seatCnt="{item}">
        {{item.seatCnt.configName}}
      </template>
      <template #created="{item}">
        {{$func.dateToString(item.created)}}
      </template>
      <template #action="{ item }">
        <c-btn icon iconName="edit" :disabled="disabledByRole" @click="openVehicleModelDialog(item)"/>
      </template>
    </c-table>
    <vehicle-model-c-u-dialog
      :open.sync="vehicleModelDialog"
      :vehicleModelFormData="vehicleModelFormData"
      @reqAddVehicleModel="reqAddVehicleModel"
      @reqUpdateVehicleModel="reqUpdateVehicleModel"
    />
  </v-container>

</template>
<script>
  import VehicleModelCUDialog from "./VehicleModelCUDialog";;

  export default {
    components: { VehicleModelCUDialog },
    data: () => ({
      vehicleModelTableHeaders: [
        {
          text: '모델명',
          value: 'modelName',
          align: 'center',
          sortable: true,
        },
        {
          text: '차종',
          value: 'seatCnt',
          align: 'center',
          sortable: true,
          sort: (a, b) => (a.configName < b.configName) ? -1 : (a.configName === b.configName) ? 0 : 1
        },
        {
          text: '등록일',
          value: 'created',
          align: 'center',
          sortable: true,
        },
        {
          text: '',
          value: 'action',
          align: 'center',
          sortable: false,
        },
      ],

      vehicleModelList: [],
      vehicleModelDialog: false, //차량 등록/수정 다이얼로그 open flag
      vehicleModelFormData: null, // api post 데이터
      selected: [],
    }),
    watch: {
      vehicleModelDialog(value) {
          if (!value) this.vehicleModelFormData = null;
      },
    },
    computed: {
      disabledByRole() {
        return this.$store.state.userInfo.role === 'RM';
      },
    },
    methods: {
      async reqAddVehicleModel(data) {
        try {
          const res = await this.$api.addVehicleModel(data);

          if ( res && res.data && res.data.code == 0 ) {
            this.vehicleModelDialog = false;
            this.reqGetVehicleModelList();
          } else {
            this.$store.commit('snackbar', {timeout: 2000, msg: res.data.message});
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddVehicle'});
        }
      },

      async reqUpdateVehicleModel(data) {
        try {
          const res = await this.$api.updateVehicleModel(data);

          if ( res && res.data && res.data.code == 0 ) {
            this.vehicleModelDialog = false;
            this.reqGetVehicleModelList();
          } else {
            this.$store.commit('snackbar', {timeout: 2000, msg: res.data.message});
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqUpdateVehicleModel'});
        }

      },

      async reqGetVehicleModelList() {
        try {
          const res = await this.$api.getVehicleModelList();
          this.vehicleModelList = res.data.map((item, idx) => {
            item.idx = idx;
            return item;
          });
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetVehicleModelList'});
        }
      },

      openVehicleModelDialog(data) {
        console.log(data);
        if ( data && data.id ) {
          this.vehicleModelFormData = {
              id: data.id,
              modelName: data.modelName,
              seatCnt: data.seatCnt.configValue
            };
        } else {
          this.vehicleModelFormData = {
              id: '',
              modelName: '',
              seatCnt: ''
            };
        }
        this.vehicleModelDialog = true;
      },
      async onDeleteVehicleModels() {
        if (this.selected.length < 1) {
          this.$store.commit('alert', {open: true, msg: '삭제할 차량모델을 선택해주세요.'});
        } else {
          this.$store.commit('alert', {
            open: true, msg: "선택한 모든 차량 모델을 삭제하시겠습니까?",
            confirm: true, persistent: true,
            callBack: () => {
              this.reqDeleteVehicleModels();
            }
          });
        }
      },
      async reqDeleteVehicleModels() {
        try {
          const res = await this.$api.deleteVehicleModels(this.selected);

          if ( res && res.data && res.data.code == 0 ) {
            this.reqGetVehicleModelList();
            this.$store.commit('snackbar', {timeout: 4000, msg: '선택한 모든 차량 모델이 삭제되었습니다.'});
          } else {
            this.$store.commit('snackbar', {timeout: 2000, msg: res.data.message});
          }
         
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqDeleteVehicleModels'});
        }
      },
    },
    activated() {
      this.reqGetVehicleModelList();
    }
  }
</script>

<style>
</style>
